import { gql } from '@apollo/client';
import { NEWSLETTER_FRAGMENT } from '../fragments/newsletter.newsletter.graphql';

export const UPSERT_NEWSLETTER_MUTATION = gql`
  mutation UpsertNewsletter(
    $where: NewsletterWhereUniqueInput!
    $create: NewsletterCreateInput!
    $update: NewsletterUpdateInput!
  ) {
    upsertNewsletter(create: $create, update: $update, where: $where) {
      ...Newsletter
    }
  }
  ${NEWSLETTER_FRAGMENT}
`;
